import React from 'react';

import { useFlowState } from '@betterment/js-runtime';
import { Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Box, Heading } from '@betterment/style-closet-react';

import { CustomerSignupValues } from './Controller';

import { useStateAgeLimitEligibilityCheck } from '../Checking/use-state-age-limit-eligibility-check';
import { trackClick } from '../features/track';
import FullPageLoader from '../Shared/components/FullPageLoader';
import { WorkflowLayout } from '../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../Shared/urlBuilder';

const CheckingStateAgeLimitEligibilityCheck: React.FC<{ handleClose: () => void }> = ({ handleClose }) => {
  const { goToNextStep, flowState } = useFlowState<CustomerSignupValues>();

  const { status, ineligibilityMessage } = useStateAgeLimitEligibilityCheck({
    isProspect: false,
    isForSecondary: false,
    onEligibility: goToNextStep,
  });

  return (
    <WorkflowLayout pageTitle="Sign up - Checking" workflowTitle={flowState.values.stepTitle} onClose={handleClose}>
      {status === 'loading' && <FullPageLoader />}
      {status === 'ineligible' && (
        <>
          <Box mb="8">
            <Icon name="ExclamationCircle" size="large" />
          </Box>
          <Heading as="h1" fontSize={[5, 6]} mb="8">
            {ineligibilityMessage.title}
          </Heading>
          <Text as="p">{ineligibilityMessage.description}</Text>
          <SambaAutoLink
            to={urlBuilder.appHome.absolute()}
            onClick={() => trackClick({ name: 'GotIt', flow: 'OpenCheckingAccount' })}
            variant="solidPrimary"
          >
            Got it
          </SambaAutoLink>
        </>
      )}
    </WorkflowLayout>
  );
};

export default CheckingStateAgeLimitEligibilityCheck;
